import { z } from "zod";
/** Строка `v_corp_admins` (контракт v2.0 §4.2). */
export const zCorpAdminRowDto = z.object({
    admin_id: z.string(),
    email: z.string(),
    full_name: z.string(),
    phone: z.string().nullish(),
    status: z.string(),
    blocked_at: z.string().nullish(),
    block_reason: z.string().nullish(),
    created_at: z.string(),
    company_ids: z.array(z.string()).nullish(),
    company_names: z.array(z.string().nullable()).nullish(),
});
/** Ответ `corp-admin-manage` на `create` (§4.5): `201 {adminId, authUuid, email, companyIds}`. */
export const zCorpAdminCreateResultDto = z.object({
    adminId: z.string(),
    authUuid: z.string().nullish(),
    email: z.string().nullish(),
    companyIds: z.array(z.string()).nullish(),
});
/** Ответ `corp_admin_set_companies` (§4.3). */
export const zCorpAdminSetCompaniesResultDto = z.object({
    adminId: z.string(),
    companyIds: z.array(z.string()).nullish(),
});
